import { updateDices } from "@/utils/dices";
import _orderBy from "lodash/orderBy";

export default {
  name: "Home",
  data() {
    return {
      username: "",
      activeUser: {
        name: ""
      },
      dices: [],
      vibrateInterval: undefined,
      notificationTimeout: undefined,
      grid: [],
      isTotal: false,
      isHistory: false,
      isNotificationVisible: false,
      askToJoin: false,
      isDiceLoading: false
    };
  },
  computed: {
    isActiveUser() {
      return this.activeUser.name !== "";
    },
    roomEvents() {
      const events = this.$store.getters["events/getRoomEvents"](
        this.$route.params.id
      );
      return _orderBy(events, ["timestamp"], ["desc"]);
    },
    latestEvent() {
      let event = {};
      const latest = this.roomEvents[0];

      if (latest) {
        event = latest;
      }

      return this.changeToNotification(event);
    },
    room() {
      return this.$store.getters["rooms/getRoom"](this.$route.params.id);
    },
    isInitialize() {
      return Boolean(this.roomEvents.length > 0 && this.room);
    },
    total() {
      let total = 0;
      this.dices.forEach(dice => {
        total = total + dice.number;
      });
      return total;
    },
    isDicesHolded() {
      return this.dices.some(dice => {
        return dice.hold;
      });
    },
    isDicesAvailable() {
      return this.dices.some(dice => {
        return !dice.hold;
      });
    }
  },
  watch: {
    room() {
      this.dices = this.room.dices;
    },
    latestEvent() {
      if (this.isActiveUser) {
        clearTimeout(this.notificationTimeout);
        this.isNotificationVisible = false;

        this.notificationTimeout = setTimeout(() => {
          this.isNotificationVisible = true;

          this.notificationTimeout = setTimeout(() => {
            this.isNotificationVisible = false;
          }, 2000);
        }, 200);
      }
    },
    roomEvents() {
      const event = this.roomEvents[0];
      if (event.type === "initialize" || event.type === "dicesChange") {
        this.dices = this.generatePosition(this.room.dices);
        this.isDiceLoading = true;
        const diceLoadingTimeout = setTimeout(() => {
          this.isDiceLoading = false;
          clearTimeout(diceLoadingTimeout);
        }, 1000);
      }

      if (event.type === "diceHold" || event.type === "diceUnhold") {
        if (this.dices.length > 0) {
          for (let i = 0; i < this.room.dices.length; i++) {
            this.dices[i].hold = this.room.dices[i].hold;
          }
        }
      }

      if (event.type === "diceUnholdAll") {
        if (this.dices.length > 0) {
          for (let i = 0; i < this.room.dices.length; i++) {
            this.dices[i].hold = false;
          }
        }
      }
    },
    isInitialize() {
      // Initialize default dice position when entering the room
      this.dices = this.generatePosition(this.room.dices);
    }
  },
  mounted() {
    this.$store.dispatch("rooms/fetchRooms");
    this.$store.dispatch("events/fetchEvents", this.$route.params.id);

    if (!this.isActiveUser) {
      this.askToJoin = true;
    }
  },
  methods: {
    toggleHistory() {
      this.isHistory = !this.isHistory;
    },
    toggleTotal() {
      this.isTotal = !this.isTotal;
    },
    joinRoom() {
      this.activeUser.name = this.username;
      this.askToJoin = false;

      this.$store.dispatch("events/pushEvent", {
        roomId: this.room.id,
        type: "join",
        data: this.dices,
        username: this.activeUser.name
      });
    },
    rollDices() {
      if (this.isDicesAvailable) {
        this.$store.dispatch("events/pushEvent", {
          roomId: this.room.id,
          type: "dicesChange",
          data: this.generatePosition(updateDices(this.dices)),
          username: this.activeUser.name
        });
      }
    },
    generateGrid() {
      const fieldElement = this.$el.querySelector(".dice-field");

      const fieldWidth = fieldElement.getBoundingClientRect().width;
      const fieldHeight = fieldElement.getBoundingClientRect().height;

      const diceSize = 55;

      const gridWidth = Math.floor(fieldWidth / diceSize) - 1;
      const gridHeight = Math.floor(fieldHeight / diceSize) - 1;

      for (let w = 0; w < gridWidth; w++) {
        for (let h = 0; h < gridHeight; h++) {
          this.grid.push({
            x: w * diceSize,
            y: h * diceSize
          });
        }
      }
    },
    generatePosition(dices) {
      if (this.grid.length === 0) {
        this.generateGrid();
      }

      let copiedGrid = [...this.grid];

      for (let i = 0; i < dices.length; i++) {
        const randomIndex = Math.random() * copiedGrid.length;
        const position = copiedGrid.splice(randomIndex, 1);
        dices[i].position = position[0];
      }

      return dices;
    },
    holdDice(index) {
      this.dices[index].hold = true;

      this.$store.dispatch("events/pushEvent", {
        roomId: this.room.id,
        type: "diceHold",
        data: this.dices,
        username: this.activeUser.name
      });
    },
    releaseDice(index) {
      this.dices[index].hold = false;

      this.$store.dispatch("events/pushEvent", {
        roomId: this.room.id,
        type: "diceUnhold",
        data: this.dices,
        username: this.activeUser.name
      });
    },
    releaseAll() {
      if (this.isDicesHolded) {
        this.dices.forEach(dice => {
          dice.hold = false;
        });

        this.$store.dispatch("events/pushEvent", {
          roomId: this.room.id,
          type: "diceUnholdAll",
          data: this.dices,
          username: this.activeUser.name
        });
      }
    },
    joinDice(dices) {
      return dices
        .map(function(dice) {
          return dice.number;
        })
        .join(", ");
    },
    changeToNotification(event) {
      const notification = {
        type: event.type,
        username: event.username,
        timestamp: event.timestamp
      };

      if (event.type === "initialize") {
        notification.message = "The room was created.";
      }

      if (event.type === "join") {
        notification.message = "has join the room.";
      }

      if (event.type === "dicesChange") {
        notification.message = `has roll: ${this.joinDice(event.data)}`;
      }

      if (event.type === "diceHold") {
        notification.message = `hold a dice.`;
      }

      if (event.type === "diceUnhold") {
        notification.message = `release a dice.`;
      }

      if (event.type === "diceUnholdAll") {
        notification.message = `release all dices.`;
      }

      return notification;
    }
  }
};
